/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactDetailsRequest
 */
export interface ContactDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactDetailsRequest
     */
    contactId: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailsRequest
     */
    cognismContactId?: string;
}

/**
 * Check if a given object implements the ContactDetailsRequest interface.
 */
export function instanceOfContactDetailsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactId" in value;

    return isInstance;
}

export function ContactDetailsRequestFromJSON(json: any): ContactDetailsRequest {
    return ContactDetailsRequestFromJSONTyped(json, false);
}

export function ContactDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'cognismContactId': !exists(json, 'cognismContactId') ? undefined : json['cognismContactId'],
    };
}

export function ContactDetailsRequestToJSON(value?: ContactDetailsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactId': value.contactId,
        'cognismContactId': value.cognismContactId,
    };
}

